/**
 * ProductSupplierOffer schemalari (Phase 7) — bir mahsulot uchun
 * bir nechta taminotchi takliflari.
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
import { currencyEnum } from './product.schema.js';
export const upsertOfferSchema = z.object({
    productId: uuidSchema,
    variantSku: z.string().min(1).max(50).optional(),
    supplierId: uuidSchema,
    unitCost: z.coerce.number().min(0),
    currency: currencyEnum,
    leadTimeDays: z.coerce.number().int().min(0).max(365).default(7),
    minOrderQty: z.coerce.number().int().min(1).default(1),
    isPreferred: z.coerce.boolean().default(false),
    note: z.string().max(500).optional(),
});
//# sourceMappingURL=product-supplier-offer.schema.js.map